export const SAVE_ACCESS_TOKEN = "SAVE_ACCESS_TOKEN";
export const SAVE_USER_INFO = "SAVE_USER_INFO";
export const SAVE_SIDE_MENU = "SAVE_SIDE_MENU";
export const LOG_OUT = "LOG_OUT";
export const SAVE_TOKEN_LIST = "SAVE_TOKEN_LIST";
export const SAVE_ROUTES = "SAVE_ROUTES";
